export var SOCIALS_ENTITIES = ['articles', 'questions', 'products', 'tags', 'profiles', 'pills', 'reviews', 'answers'];